import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type LetterIconProps = CommonSvgProps

const LetterIcon: React.FC<LetterIconProps> = React.forwardRef<SVGSVGElement, LetterIconProps>(
  (props, ref) => (
    <Svg viewBox="0 0 58 72" {...props} ref={ref} color="none">
      <path
        d="M55.9126 20.8877L39.4126 4.3877L36.4126 2.3877L34.9126 4.3877L35.9126 22.3877L55.9126 23.3877V20.8877Z"
        fill="#7BB835"
      />
      <path
        d="M37.5416 1.8335H8.49996C6.68765 1.8335 4.94956 2.55343 3.66806 3.83493C2.38656 5.11643 1.66663 6.85452 1.66663 8.66683V63.3335C1.66663 65.1458 2.38656 66.8839 3.66806 68.1654C4.94956 69.4469 6.68765 70.1668 8.49996 70.1668H49.5C51.3123 70.1668 53.0503 69.4469 54.3318 68.1654C55.6133 66.8839 56.3333 65.1458 56.3333 63.3335V20.6252L37.5416 1.8335Z"
        stroke="#51565C"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.8334 1.8335V22.3335H56.3334"
        stroke="#51565C"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.6667 39.4165H15.3334"
        stroke="#53A2D9"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.6667 53.0835H15.3334"
        stroke="#53A2D9"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.1667 25.75H15.3334"
        stroke="#53A2D9"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
)

LetterIcon.propTypes = commonPropTypes
LetterIcon.defaultProps = commonDefaultProps

export default LetterIcon
